export default __webpack_public_path__ + "static/media/sassy-emoji.751c0f48.png";